import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { setSSROrigin } from "ssr-hook";

import App from "./App";

import "ckeditor5/dist/ckeditor5.css";
import "react-responsive-modal/styles.css";

const rootElement = document.getElementById("root") as HTMLElement;

if (process.env.NODE_ENV === "development") {
    const PORT = process.env.PORT_SERVER;
    setSSROrigin("http://localhost:" + PORT); // development server
    createRoot(rootElement).render(
        <React.StrictMode>
            <App />
        </React.StrictMode>,
    );
} else {
    hydrateRoot(rootElement, <App />);
}
